import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeObjCPV } from '../models/TypeObjCPV';
import { TypeCPVClass } from '../models/TypeCPVClass';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step2 } from '../../../../shared/models/component-messages/diveIN/step2';

@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeObjCPV';
  @Input() parentForm: FormGroup;
  @Input() cpv: TypeObjCPV;
  @Input() disabled: boolean;

  public step2 = new Step2();

  constructor() {
  }

  public ngOnInit() {
    if (this.cpv !== null && this.cpv.objetComplementaire === null) {
      this.cpv.objetComplementaire = [];
    }
  }

  public addtypeCPVClass() {
    if (this.cpv.objetComplementaire.length < 4) {
      this.cpv.objetComplementaire.push(new TypeCPVClass());
    }
  }

  public removetypeCPVClass(i) {
    ArrayPopTools.pop(this.cpv.objetComplementaire, i, this.parentForm, this.getUid());
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    for (let index = 0; index < preference?.content?.values.length; index++) {
      const element = preference?.content?.values[index];
      if (index === 0) {
        this.parentForm.get(this.getUid() + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
        this.parentForm.get(this.getUid() + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
      } else {
        if (this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale') === null) {
          this.addtypeCPVClass();
          setTimeout(() => {
            this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code)
            this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched()
          },100)
        } else {
          this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.setValue(element?.code);
          this.parentForm.get(this.getUid() + '_index_' + index + '_SepSep_TypeCPVClass_SepAtt_classPrincipale')?.markAsTouched();
        }
      }

    }
  }
}

